<template>

  <div class="mobile-wrapper">
    <div
        :style="backgroundColor"
        class="justify-content-center so-register text-center"
    >
      <div
          v-if="Logo && Logo.length"
          class="big-logo"
          style="margin-top: -1rem"
      >
        <img :src="Logo"/>
      </div>

      <h2 v-else class="w-100 text-center mt-5 mb-3 text-white">
        {{ currentStoreDoc.Name }}
      </h2>

      <div class="step-title">
        {{ $t("message.soRegisterLastStepMessage") }}
      </div>
      <div class="step-desc">{{ $t("message.soRegisterLastStepDesc") }}</div>
      <div
          class="col-md-9 bg-white py-4 form-container w-75 text-left shadow-lg"
      >
        <register :full-screen="true"/>
      </div>
    </div>

  </div>
</template>

<script>
import Register from "@/components/user/register";
import {mapGetters} from "vuex";

export default {
  components: {
    Register
  },
  mounted() {
    if (!this.isBranded()) {
      const loginFlagEnabled = this.viewConfig.LogIn
      if(!loginFlagEnabled) {
        this.$router.back()
      }
    }
  },
  methods: {
    goBack() {
      if (!this.$route.params.storename) {
        this.$router.back()
        return
      }
      this.$router.push("/store/" + this.$route.params.storename);
    },
  },
  computed: {
    ...mapGetters(["desktopStyles", "hqDoc", "currentStoreDoc", "getStoreWalletDoc", "getStoreColor", "viewConfig"]),
    Logo() {
      if (this.currentStoreDoc && this.currentStoreDoc.Logo) {
        return this.currentStoreDoc.Logo;
      }
      if (
          this.currentStoreDoc &&
          this.currentStoreDoc.ThemeSettings &&
          this.currentStoreDoc.ThemeSettings.BackgroundPhotos
      ) {
        return this.currentStoreDoc.ThemeSettings.BackgroundPhotos.CommonLogo;
      }
      return "";
    },
    backgroundColor() {
      let styles = [];
      let colour = this.getStoreColor;

      styles.push({"background-color": `${colour}`});
      return styles;
    },
    storeThemeConfiguration() {
      if (!this.getStoreWalletDoc || !this.getStoreWalletDoc.ThemeConfiguration) {
        return null
      }

      return this.getStoreWalletDoc.ThemeConfiguration
    },

  },
};
</script>
